import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhotosynIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.627 12.018H16.9851C16.9851 13.3274 16.4556 14.5085 15.5955 15.3686C14.7353 16.2288 13.5543 16.7551 12.2448 16.7583C10.9354 16.7583 9.75429 16.2288 8.89417 15.3686C8.03404 14.5085 7.50769 13.3274 7.50448 12.018C7.50448 10.7085 8.03404 9.52747 8.89417 8.66734C9.75429 7.80721 10.9354 7.28084 12.2448 7.27763C13.5543 7.27763 14.7353 7.80721 15.5955 8.66734C16.4556 9.52747 16.9819 10.7085 16.9851 12.018H17.627H18.2689C18.2689 8.68979 15.573 5.99386 12.2448 5.99386C8.91663 5.99386 6.2207 8.68979 6.2207 12.018C6.2207 15.3462 8.91663 18.0421 12.2448 18.0421C15.573 18.0421 18.2689 15.3462 18.2689 12.018H17.627Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.603 1.32095V4.03291C11.603 4.38595 11.8919 4.67479 12.2449 4.67479C12.598 4.67479 12.8868 4.38595 12.8868 4.03291V1.32095C12.8868 0.967915 12.598 0.679066 12.2449 0.679066C11.8919 0.679066 11.603 0.964705 11.603 1.32095Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.603 20.0031V22.7151C11.603 23.0682 11.8919 23.357 12.2449 23.357C12.598 23.357 12.8868 23.0682 12.8868 22.7151V20.0031C12.8868 19.6501 12.598 19.3613 12.2449 19.3613C11.8919 19.3613 11.603 19.6501 11.603 20.0031Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3572 4.00092L17.4412 5.91694C17.1908 6.16728 17.1908 6.5749 17.4412 6.82524C17.6915 7.07557 18.0991 7.07557 18.3494 6.82524L20.2655 4.90918C20.5158 4.65884 20.5158 4.25126 20.2655 4.00092C20.0151 3.75058 19.6075 3.74737 19.3572 4.00092Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.14676 17.2113L4.23072 19.1273C3.98038 19.3776 3.98038 19.7852 4.23072 20.0356C4.48106 20.2859 4.88866 20.2859 5.139 20.0356L7.05502 18.1195C7.30535 17.8692 7.30535 17.4616 7.05502 17.2113C6.80468 16.9609 6.3971 16.9609 6.14676 17.2113Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9417 11.3761H20.2298C19.8767 11.3761 19.5879 11.6649 19.5879 12.018C19.5879 12.371 19.8767 12.6599 20.2298 12.6599H22.9417C23.2948 12.6599 23.5836 12.371 23.5836 12.018C23.5836 11.6617 23.298 11.3761 22.9417 11.3761Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.26011 11.8647H1.54814C1.1951 11.8647 0.90625 12.1535 0.90625 12.5066C0.90625 12.8596 1.1951 13.1484 1.54814 13.1484H4.26011C4.61315 13.1484 4.902 12.8596 4.902 12.5066C4.902 12.1503 4.61636 11.8647 4.26011 11.8647Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2655 19.1273L18.3494 17.2113C18.0991 16.9609 17.6915 16.9609 17.4412 17.2113C17.1908 17.4616 17.1908 17.8692 17.4412 18.1195L19.3572 20.0356C19.6075 20.2859 20.0151 20.2859 20.2655 20.0356C20.5158 19.7852 20.5158 19.3776 20.2655 19.1273Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.05211 5.91707L5.13607 4.00105C4.88573 3.75071 4.47813 3.75071 4.22779 4.00105C3.97746 4.25138 3.97746 4.65897 4.22779 4.9093L6.14383 6.82536C6.39417 7.0757 6.80177 7.0757 7.05211 6.82536C7.30244 6.57503 7.30565 6.1674 7.05211 5.91707Z",
			fill: "#2C3F81"
		})
	]
});
export default SvgPhotosynIcon;
